const BACKEND_URL = 'http://ec2-54-175-96-219.compute-1.amazonaws.com:3000';
export default BACKEND_URL;


// WEBPACK FOOTER //
// ./src/config.js